import { useState } from "react";
import { BookOpen } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { ForgotPasswordForm } from "../components/ForgotPasswordForm";

export default function LoginPage() {
  const { authenticate } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await authenticate("/auth/login", form);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-side border-r border-line text-ink p-12 ledger-grid-dark relative overflow-hidden">
        <div className="flex items-center gap-2 font-display text-xl font-semibold">
          <BookOpen className="h-6 w-6 text-brand" /> SiteLedger
        </div>
        <div className="rise">
          <p className="font-mono text-xs uppercase tracking-widest text-brand mb-4">Site · Branch · Ledger</p>
          <h1 className="font-display text-5xl font-bold leading-tight">Every rupee,<br />every site,<br />every day.</h1>
          <p className="mt-6 text-ink2 max-w-md">Record deposits and withdrawals per branch, review them date-wise, and export a clean PDF in one click.</p>
        </div>
        <p className="font-mono text-xs text-muted-c">₹ INR ledger</p>
      </div>

      <div className="flex items-center justify-center p-6 ledger-grid">
        {forgot ? <ForgotPasswordForm onBack={() => setForgot(false)} /> : <form onSubmit={submit} className="w-full max-w-sm bg-surface border border-line p-8 rise" data-testid="auth-form">
          <h2 className="font-display text-3xl font-bold tracking-tight">Sign in</h2>
          <p className="text-sm text-muted-c mt-1 mb-6">Access your site books</p>
          <div className="mb-4">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="login-email-input" value={form.email} onChange={set("email")} className="mt-1 rounded-none" />
          </div>
          <div className="mb-4">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required minLength={6} data-testid="login-password-input" value={form.password} onChange={set("password")} className="mt-1 rounded-none" />
          </div>
          {error && <p className="text-sm text-neg mb-3" data-testid="auth-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="login-submit-button" className="w-full rounded-none bg-brand hover:bg-brand/90 text-onbrand">
            {busy ? "Please wait…" : "Sign in"}
          </Button>
          <button type="button" onClick={() => setForgot(true)} className="mt-4 text-sm text-brand hover:underline w-full text-center" data-testid="forgot-password-link">
            Forgot password?
          </button>
        </form>}
      </div>
    </div>
  );
}
